import router from './router'
import store from './store'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import { resetUserSessionStorage } from '@/utils/util'
// import { getUrlCode } from "@/utils/urlFormat";

const whiteList = ['/login', '/auth-redirect', '/bind', '/register']
// // 处理CA跳转过来的数据
// let ticket = getUrlCode('user')
// let ad = getUrlCode('ad')
// if (ticket !== undefined && ticket !== null && ticket !== '') {
//   store.dispatch('saveCAInfo', {ticket: ticket, ad: ad}).then(() => {
//     console.log('存储CA', ticket)
//   }).catch(() => {
//     console.log('存储CA出错', ticket)
//   })
// }

router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (to.path === '/login') {
      next()
    } else {
      // 从员工看板点击返回后逻辑处理
      if (to.path === '/entiretyDetail' || to.path === '/OperateDetail' || to.path === '/') {
        // let queryToken = to.query.token
        // resetUserSessionStorage(queryToken)
        let queryTm = to.query.tm
        resetUserSessionStorage(queryTm)
      }
      if (JSON.stringify(store.getters) === '{}') {
        // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch('GetInfo')
          .then((res) => {
            next()
          })
          .catch((err) => {
            store.dispatch('LogOut').then(() => {
              Message.error(err)
              next({ path: '/' })
            })
          })
      } else {
        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js